// extracted by mini-css-extract-plugin
module.exports = {"animation-fast-ms":"300","animation-slow-ms":"800","FeedbackButton":"index__FeedbackButton___C3IB9 typography__heading___3ravE"};